import { post } from "Service";

const initiatePayment = (payload: any) => {
  const request = {
    subUrl: `initiate`,
    data: payload,
    isPayment: true,
  };
  return post(request);
};

const PaymentApi = {
  initiatePayment,
};

export default PaymentApi;
